// extracted by mini-css-extract-plugin
export default {"eventRow":"EventRow_eventRow__abSo2"};